import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { CreateTrainingModuleDialog } from "components/TrainingContent/TrainingModule/CreateTrainingModuleDialog"
import { TrainingModuleList } from "components/TrainingContent/TrainingModule/TrainingModuleList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import simulatorApplicationService from "services/simulatorApplicationService"
import { setCurrentSimulatorApplication } from "slices/simulatorApplicationSlice"

export function Simulator() {
  const currentSimulator = useAppSelector(
    (state) => state.simulatorapplication.currentSimulatorApplication,
  )
  const { id } = useParams()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (currentSimulator !== undefined) {
      return
    }

    if (id === undefined) {
      return
    }

    simulatorApplicationService
      .getSimulatorApplication(id)
      .then((simulator) => {
        dispatch(setCurrentSimulatorApplication(simulator))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [currentSimulator, dispatch, id])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>{currentSimulator?.name}</Title>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>TRAINING MODULES</Title>
            </Grid>
            <Grid item>
              <CreateTrainingModuleDialog />
            </Grid>
          </Grid>
          {currentSimulator && <TrainingModuleList app={currentSimulator} />}
        </Paper>
      </Grid>
    </Grid>
  )
}
